//
//
//
//
//
//

import registerLocalEntitiesAtPlatformLevel from './store/registerLocalEntitiesAtPlatformLevel'

export default {
  name: 'App',
  created () {
    // from https://github.com/vuejs/vuex/issues/1244#issuecomment-547971322
    // this is needed to be able to access vuex module name from within the module.  that is sometimes needed for modules that use inheritance from other modules to be created
    this.$store.dispatch('bindNamespaces', this.$store)

    // register platform level localEntities
    registerLocalEntitiesAtPlatformLevel()
  }
}
